export enum RequestHeader {
  UploadFile = 'uploadFile',
  XValidateFile = 'X-Validate-File',
  ETag = 'ETag',
  IfMatch = 'If-Match',
  CacheControl = 'Cache-Control',
  Pragma = 'Pragma'
}
